export class RingBuffer<T> {
  private items: T[] = []
  constructor(private readonly max: number) {}

  push(item: T): void {
    this.items.push(item)
    while (this.items.length > this.max) this.items.shift()
  }

  snapshot(): T[] {
    return this.items.slice()
  }

  clear(): void {
    this.items.length = 0
  }
}
